import React from "react";
import PropTypes from "prop-types";
import get from "lodash/get";
import { ResponsiveImage } from "@quintype/components";
import { processHtmlLinks, isValidUrl } from "../../../../utils/html-utils";
import "./ImageElement.m.css";

const ImageElement = ({ element, hasLeftImage, hasRightImage, hasMultiImage, isLeadership }) => {

  const stripHtml = (html) => {
    if (!html) return "";
    return html.replace(/<[^>]*>?/gm, "");
  };

  const imageS3Key = get(element, ["image-s3-key"], "");
  const imageMetadata = get(element, ["metadata"], {});
  const imageCaption = get(element, ["title"], "");
  const imageCaptionPlainText = stripHtml(imageCaption);
  const rawAttribution = stripHtml(get(element, ["image-attribution"], ""));
  const imageAttribution = rawAttribution
    ?.replace(/&nbsp;/g, " ")
    ?.replace(/\u00A0/g, " ");

  const hyperlink =
    get(element, ["hyperlink"], "") ||
    get(element, ["metadata", "hyperlink"], "") ||
    get(element, ["image-metadata", "hyperlink"], "") ||
    get(element, ["metadata", "url"], "") ||
    (typeof element?.url === "string" && isValidUrl(element.url) ? element.url : "");
  const isValidHyperlink = isValidUrl(hyperlink);

  if (!imageS3Key) return null;
  let variantClass = "";
  if (hasLeftImage) variantClass = "left-image-element";
  else if (hasRightImage) variantClass = "right-image-element";
  else if (hasMultiImage) variantClass = "multi-image-element";

  const shouldHideCaption = hasLeftImage || hasRightImage || hasMultiImage;

  const imageNode = (
    <ResponsiveImage
      slug={imageS3Key}
      metadata={imageMetadata}
      aspectRatio={[16, 9]}
      defaultWidth={800}
      widths={[800, 1200]}
      imgParams={{ auto: ["format", "compress"] }}
      eager="below-fold"
      alt={imageCaptionPlainText || ""}
    />
  );

  return (
    <div styleName={`story-element image-element ${variantClass} ${shouldHideCaption ? 'hide-caption-attribution' : ''} ${isLeadership ? 'leadership-image' : ''}`}>
      <div styleName={`image-with-attribution ${imageAttribution ? 'has-attribution' : ''}`}>
        <div styleName="image-container">
          <div styleName="article-image">
            {isValidHyperlink ? (
              <a
                href={hyperlink}
                target="_blank"
                rel="noopener"
                styleName="image-link"
                {...(imageCaptionPlainText ? { "aria-label": imageCaptionPlainText } : {})}
              >
                {imageNode}
              </a>
            ) : (
              imageNode
            )}
          </div>
        </div>
        {imageAttribution && (
          <span styleName="attribution-vertical">{imageAttribution}</span>
        )}
      </div>

      {imageCaption && (
        <div styleName="image-caption-wrapper">
          <span styleName="caption-horizontal" dangerouslySetInnerHTML={{ __html: processHtmlLinks(imageCaption) }} />
        </div>
      )}
    </div>
  );
};

ImageElement.propTypes = {
  element: PropTypes.object.isRequired,
  hasLeftImage: PropTypes.bool,
  hasRightImage: PropTypes.bool,
  hasMultiImage: PropTypes.bool,
  isLeadership: PropTypes.bool,
};

export default ImageElement;
